import React from "react"
import { motion } from "framer-motion"
import { AnimatedGradient } from "../ui/animated-gradient-with-svg"

const BentoCard = ({
  title,
  value,
  colors,
  delay,
}) => {
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: delay + 0.3,
      },
    },
  }

  const item = {
    hidden: { opacity: 0 },
    show: { opacity: 1, transition: { duration: 0.5 } },
  }

  return (
    <motion.div
      className="relative overflow-hidden h-full bg-background dark:bg-background/50"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, delay }}
    >
      <AnimatedGradient colors={colors} speed={0.05} blur="medium" />
      <motion.div
        className="relative z-10 p-3 sm:p-5 md:p-8 text-foreground backdrop-blur-sm h-full flex flex-col justify-center items-center text-center"
        variants={container}
        initial="hidden"
        animate="show"
      >
        <motion.h3 
          className="text-base sm:text-lg md:text-xl font-medium text-foreground/80 font-display" 
          variants={item}
        >
          {title}
        </motion.h3>
        <motion.p
          className="text-3xl sm:text-5xl md:text-6xl font-bold mb-4 text-foreground font-display"
          variants={item}
        >
          {value}
        </motion.p>
      </motion.div>
    </motion.div>
  )
}

function Stats(){
  return (
    <section className="py-12 mx-4 md:mx-8">
      <div className="text-center max-w-3xl mx-auto mb-20">
        <h4 className="text-primary font-medium">
          Our Impact
        </h4>
        <h2 className="text-3xl font-bold mb-8">
          Delivering Results That Matter
        </h2>
        <p className="mt-4 text-xl text-gray-600">
          See how our solutions transform businesses through measurable outcomes and significant improvements.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 grow h-full">
        <BentoCard
          title="Average Shipping Time"
          value="2 days"
          colors={["#60a5fa", "#3b82f6", "#2563eb"]}
          delay={0.2}
        />
        <BentoCard
          title="Average Savings Per Shipment"
          value="80%"
          colors={["#34d399", "#10b981", "#059669"]}
          delay={0.3}
        />
        <div className="md:col-span-2">
          <BentoCard
            title="Average Increase in International Revenue"
            value="100%"
            colors={["#fb923c", "#f97316", "#ea580c"]}
            delay={0.4}
          />
        </div>
      </div>
    </section>
  )
}

export default Stats;